<template>
  <div class="flex flex-wrap flex flex-row my-4 md:my-0 filters-preview__wrapper">
    <div class="w-full md:hidden">
    </div>
    <el-button v-if="activeFilters.length > 0"
               class="py-3 px-4 mr-3 mt-2 md:mt-0 rounded-lg cursor-pointer bg-primary shadow-lg text-white text-base font-semibold"
               @click="clearAllFilters">{{this.$t('common.clearAll')}}
    </el-button>
    <div v-for="item in activeFilters" :key="item.value"
         class="inline-flex flex-wrap shadow-lg py-1 px-3 mr-2 my-1 md:my-2 rounded-full text-primary-darker text-xs md:text-sm bg-primary-lighter font-semibold cursor-pointer filter-preview__item segment-tag">
      <div class="flex items-center">
        <span class="text-primary-darker">{{item.value}}</span>
        <x-icon class="ml-1 h-full cursor-pointer w-4 text-black filter-preview__close-icon"
                @click="removeFilter(item.id)"></x-icon>
      </div>
    </div>
  </div>
</template>

<script>
  import { XIcon } from 'vue-feather-icons'

  export default {
    name: 'filters-preview',
    components: {
      XIcon
    },
    props: {
      segments: Array,
      default: () => []
    },
    computed: {
      activeFilters() {
        if (!Object.keys(this.$store.getters['getSegmentsById']).length) {
          return []
        }
        return this.segments.map(id => this.$store.getters['getSegmentsById'][id])
      },
    },
    methods: {
      removeFilter(id) {
        const newSegments = this.segments.filter(segmentId => segmentId !== id.toString())
        this.$emit('change', newSegments)
      },
      clearAllFilters() {
        this.$emit('change', [])
      }
    }
  }
</script>
